import { ConverterJob } from '../models/internal/converterJob';
import { Demand } from '../../demands/models/demand';
import { Inquiry } from '../../inquiries/models/inquiry';
import { PurchaseOrder } from '../../purchase-orders/models/purchaseOrder';
import { SalesOrder } from '../../sales-orders/models/salesOrder';
import { TransitionSource } from '../models/type-transition-source';
import { createConverterJobFromDemand } from './converter-job-factory-demand';
import { createConverterJobFromInquiry } from './converter-job-factory-inquiry';
import { createConverterJobFromPurchaseOrder } from './converter-job-factory-purchase-order';
import { createConverterJobFromSalesOrder } from './converter-job-factory-sales-order';

export class ConverterJobFactory {
    public static CreateConverterJob(source: TransitionSource): ConverterJob | undefined {
        let job: ConverterJob | undefined;
        try {
            // Create converterJob
            if (source instanceof Inquiry) {
                job = createConverterJobFromInquiry(source);
            }

            if (source instanceof PurchaseOrder) {
                job = createConverterJobFromPurchaseOrder(source);
            }

            if (source instanceof SalesOrder) {
                job = createConverterJobFromSalesOrder(source);
            }

            if (source instanceof Demand) {
                job = createConverterJobFromDemand(source);
            }

            // If there is only one customer present, preselect this one, otherwise preselect "all customers"
            if (job) {
                job.selectedCustomerId = job.customers.length === 1 ? job.customers[0].id : -1;
            }

            return job;
        } catch {
            return job;
        }
    }
}
